import React from 'react'
import { AttachMoney } from '@material-ui/icons'
import { Box, Button, Typography, makeStyles } from '@material-ui/core'
import { money } from '../utils'

const useStyles = makeStyles(theme => ({
  selectionBar: {
    position: 'sticky',
    top: 72,
    zIndex: 4,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    background: '#fff8f2',
    border: '1px solid #f2b27f',
    borderRadius: 6,
    boxShadow: '0 4px 12px rgba(178, 75, 0, 0.08)'
  },
  selectionCount: { fontWeight: 700, color: '#8b3e08' },
  selectionMeta: { color: '#6e6259', fontSize: 13 },
  selectionTotal: {
    marginLeft: 'auto',
    fontSize: 19,
    fontWeight: 800,
    color: '#b84d00',
    fontVariantNumeric: 'tabular-nums'
  },
  '@media (max-width: 600px)': { selectionTotal: { marginLeft: 0 } }
}))

interface Props {
  conceptCount: number
  includeGoal: boolean
  mutating: boolean
  total: number
  onLiquidate: () => void
}

const SelectionBar: React.FC<Props> = ({ conceptCount, includeGoal, mutating, total, onLiquidate }) => {
  const classes = useStyles()
  return (
    <Box className={classes.selectionBar}>
      <Box>
        <Typography className={classes.selectionCount}>{conceptCount} conceptos seleccionados</Typography>
        <Typography className={classes.selectionMeta}>
          {includeGoal ? 'Bono meta incluido' : 'Bono meta no incluido'}
        </Typography>
      </Box>
      <Typography className={classes.selectionTotal}>{money(total)}</Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AttachMoney />}
        disabled={mutating || total <= 0}
        onClick={onLiquidate}
      >
        Liquidar comisión
      </Button>
    </Box>
  )
}

export default SelectionBar
